export default "../css/230a57e22ebe26cf59964b6b5a56cc45.ttf";